import { render, staticRenderFns } from "./tiktokUserItem.vue?vue&type=template&id=047c0c85"
import script from "./tiktokUserItem.vue?vue&type=script&lang=js"
export * from "./tiktokUserItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports